var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoStarRewards = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7.389 1.239 1.785 3.535 3.434.34a.437.437 0 0 1 .367.283.426.426 0 0 1-.102.45l-2.83 2.8 1.049 3.807a.427.427 0 0 1-.144.446.438.438 0 0 1-.47.053L7 11.23l-3.478 1.725a.438.438 0 0 1-.608-.255.426.426 0 0 1-.005-.244l1.048-3.808-2.83-2.804a.429.429 0 0 1 .265-.732l3.434-.34 1.785-3.535A.432.432 0 0 1 7.001 1a.438.438 0 0 1 .388.239Z",
  fill: "#FACC15",
  stroke: "#FACC15",
  strokeWidth: 0.272,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgIcoStarRewards as ReactComponent };
export default __webpack_public_path__ + "assets/media/ico_star_rewards.eaa003fad7ccb48ba6c25f0a3ae6df19.svg";